import React from "react";

export const Logo = ({ className = "h-10" }) => (
  <img
    src="/logo.png"
    alt="PNG Landed Excellence"
    className={`${className} w-auto`}
    data-testid="site-logo"
  />
);
